declare global {
  interface Window {
    zr: {
      page?: ServerJsVariables;
      event: unknown;
    }
  }
}

type ServerJsVariables = Record<string, unknown>;

/**
 * Read js_variables object sent from server and prepare window.zr.event object
 */
export function readPageData(): ServerJsVariables {
  // Reads JSON data stored in the markup using add_js_variable() and stores it in zr.page. e.g. zr.page.model or zr.page.translations
  window.zr = window.zr || {};
  window.zr.page = JSON.parse(document.getElementById('js_variables')?.innerHTML || '') as ServerJsVariables;
  window.zr.page = window.zr.page || {};

  // The JS logging expects zr.event not zr.page.event.
  window.zr.event = {
    ...(window.zr.page.event as Record<never, never>),
    ...(window.zr.event as Record<never, never>),
  };
  delete window.zr.page.event;
  return window.zr.page;
}
